import { Alert } from '@centecomm/portal-service';
import DynamicTranslatedContent from 'Core/i18n/Components/DynamicTranslatedContent';
import { IconColors } from 'Icons';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'Shared/Button';

const EmergencyAlert: React.FC<{ alert: Alert; dismiss: (id: number) => void }> = ({ alert, dismiss }) => {
    const { t } = useTranslation(['communicationsFeature', 'buttons']);

    return (
        <div
            style={{
                padding: '1rem',
                borderRadius: '0.25rem',
                margin: '0 0 1rem',
                background: IconColors.WarningRed,
                color: IconColors.White,
            }}
        >
            <h2 style={{ fontSize: '1.5rem', margin: '0 0 1rem' }}>{t('communicationsFeature:alerts.emergencyAlert')}</h2>
            <h3 style={{ fontSize: '1.25rem', margin: '0.5rem 0 1rem' }}>
                {t('communicationsFeature:alerts.alertForProperty', { propertyName: alert.propertyName })}
            </h3>
            <DynamicTranslatedContent
                content={alert.alertMessage}
                showLoadingState
                extendedOptions={{
                    bypassMainAppLanguage: true,
                }}
            >
                {({ translatedContent }) => (
                    <p
                        style={{
                            fontSize: '1rem',
                            lineHeight: '1.6',
                            margin: '0 0 1rem',
                            maxWidth: '40rem',
                            overflowWrap: 'break-word',
                        }}
                    >
                        {translatedContent}
                    </p>
                )}
            </DynamicTranslatedContent>
            <Button
                callback={() => {
                    dismiss(alert.alertId);
                }}
                text={t('buttons:dismiss')}
                inverse
                warning
                reverse
            />
        </div>
    );
};

export default EmergencyAlert;
